// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"e7343be9","667":"ac6e5139","977":"e9ab4c5d"}[chunkId] + ".chunk.js";
};